import { UserButton } from "@clerk/clerk-react";
import { NavLink, Outlet } from "react-router-dom";

const nav = [
  { to: "/", label: "Home", end: true },
  { to: "/activity", label: "Activity" },
];

export function AgentShell() {
  return (
    <div style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1.5rem",
          padding: "1rem 1.75rem",
          background: "var(--sdw-surface)",
          borderBottom: "1px solid var(--sdw-border)",
        }}
      >
        <div style={{ fontWeight: 800, fontSize: "1.1rem", letterSpacing: "-0.04em" }}>SurgeDial</div>
        <nav style={{ display: "flex", gap: "0.5rem" }}>
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              style={({ isActive }) => ({
                padding: "0.4rem 0.75rem",
                borderRadius: "999px",
                fontSize: "0.88rem",
                fontWeight: 600,
                color: isActive ? "#fff" : "var(--sdw-muted)",
                background: isActive ? "var(--sdw-accent)" : "transparent",
                textDecoration: "none",
              })}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <span style={{ marginLeft: "auto" }}>
          <UserButton afterSignOutUrl="/" />
        </span>
      </header>
      <main style={{ flex: 1, padding: "1.75rem 2rem", maxWidth: "52rem", margin: "0 auto", width: "100%" }}>
        <Outlet />
      </main>
    </div>
  );
}
